import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { Col } from 'react-bootstrap';
import StorageBrazeCard from 'src/cms-components/StorageBrazeCard/StorageBrazeCard';
import ProductCard from 'src/components/product_card/ProductCard';
import { useBrazeContext } from 'src/hooks/useBraze/useBraze';
import { formatBazaarVoiceId, formatSku } from 'src/utils/helpers';

type Props = {
  relatedProducts: ProductCard[];
  title: string;
};

const ArticleProductsList = (props: Props) => {
  const { brazeCardPayloads, brazeCardSlots, loaded } = useBrazeContext();
  const renderRelatedProducts = props.relatedProducts.map(product => {
    const url = product.path.alias;
    const linkDirect = product.field_alternate_url;
    const productImage = product.relationships?.image?.gatsbyImage;
    productImage.width = 334;
    productImage.height = 304;
    const bvId = formatBazaarVoiceId(product?.field_bazaarvoice_id);
    const psId = formatSku(product?.field_pricespider_id ?? '');
    return (
      <ProductCard
        key={product.drupal_id}
        drupalId={`${product.drupal_id}`}
        title={product.title}
        bvID={bvId}
        psID={psId}
        image={productImage}
        link={url}
        linkDirect={linkDirect}
        type="products"
        outlinedCta
        onClick={() => {
          sendIt({
            event: 'module_interaction',
            eventParams: {
              component_id: props.title,
              component_type: 'product_card',
              content_name: 'product_card: related',
            },
          });
        }}
      />
    );
  });
  return (
    <Col
      md={3}
      sm={12}
      className="max-sm:!pds-mt-5 pds-flex pds-h-fit pds-flex-col pds-justify-center pds-gap-5 pds-pb-4"
    >
      {loaded && brazeCardSlots.length > 0
        ? [
            <StorageBrazeCard defaultCard={brazeCardSlots[0]} brazeCard={brazeCardPayloads[0]} />,
            ...renderRelatedProducts.slice(0, 2),
          ]
        : renderRelatedProducts}
    </Col>
  );
};

export default ArticleProductsList;
